import GroupMessageProvider from './GroupMessageProvider'

export default class TimeZoneGroupMessageProvider extends GroupMessageProvider {

    getGroupNameSingularKey = () => {
        return "common.Time_Zone_Group"
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/TimeZoneGroupMessageProvider.js